<template>
  <v-app>
    <!-- ------------------------------------------------------------------- -->
    <!-- Appbar -->
    <!-- ------------------------------------------------------------------- -->
    <v-app-bar app clipped-left color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Orion Stereo</v-toolbar-title>
    </v-app-bar>
    <!-- ------------------------------------------------------------------- -->
    <!-- Navigation drawer -->
    <!-- ------------------------------------------------------------------- -->
    <v-navigation-drawer fixed v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-row justify="center">
        <v-avatar :tile="false" :size="80" class="my-2">
          <img src="../assets/img/orion.png" alt="orion stereo" />
        </v-avatar>
      </v-row>
      <v-layout tag="v-list" column>
        <v-list dense nav>
          <template v-for="(link, i) in links">
            <!-- --------------------------------------------------------- -->
            <!-- Routes -->
            <!-- --------------------------------------------------------- -->
            <v-list-item
              :key="i"
              :to="link.to"
              link
            >
              <v-list-item-icon>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ link.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item @click="signout()">
            <v-list-item-icon>
              <v-icon>fas fa-sign-out-alt</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-layout>
    </v-navigation-drawer>
    <!-- ------------------------------------------------------------------- -->
    <!-- Seccion de contenido -->
    <!-- ------------------------------------------------------------------- -->
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      drawer: true,
      links: [
        {
          text: 'Matutina',
          icon: 'fas fa-bookmark',
          to: { name: 'matutina' }
        },
        {
          text: 'Pensamiento del día',
          icon: 'fas fa-quote-left',
          to: { name: 'pensamiento' }
        },
        {
          text: 'Programación',
          icon: 'fas fa-broadcast-tower',
          to: { name: 'programacion' }
        },
        {
          text: 'Libros',
          icon: 'fas fa-book',
          to: { name: 'libro' }
        },
        {
          text: 'Notificaciones',
          icon: 'fas fa-comment',
          to: { name: 'notificacion' }
        },
        {
          text: 'Comentarios y sugerencias',
          icon: 'fas fa-comments',
          to: { name: 'sugerencias' }
        },
        {
          text: 'Pedidos de oración',
          icon: 'fas fa-praying-hands',
          to: { name: 'oraciones' }
        },
        {
          text: 'Carrusel',
          icon: 'fas fa-image',
          to: { name: 'slides' }
        },
        {
          text: 'Videos',
          icon: 'fab fa-youtube',
          to: { name: 'videos' }
        },
        {
          text: 'Galeria',
          icon: 'fas fa-images',
          to: { name: 'galeria' }
        },
        {
          text: 'Mensajes',
          icon: 'fas fa-comment-dots',
          to: { name: 'mensajes' }
        },
        {
          text: 'Instagram',
          icon: 'fab fa-instagram',
          to: { name: 'instagram' }
        },
        {
          text: 'Instagram hashtags',
          icon: 'fas fa-hashtag',
          to: { name: 'hashtags' }
        },
        {
          text: 'Encuestas',
          icon: 'fas fa-clipboard-list',
          to: { name: 'encuestas' }
        }
      ]
    }
  },
  beforeMount () {
    const token = `Bearer ${sessionStorage.getItem('token')}`
    for (var service in this.$http) {
      const module = this.$http[service]
      module.defaults.headers.common['Authorization'] = token
    }
  },
  methods: {
    signout () {
      sessionStorage.clear()
      this.$router.push({ name: 'auth' })
    }
  }
}
</script>
